"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function asyncGeneratorStep(e, t, r, a, o, n, u) {
  try {
    var s = e[n](u),
      i = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(i) : Promise.resolve(i).then(a, o);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (a, o) {
      var n = e.apply(t, r);
      function u(e) {
        asyncGeneratorStep(n, a, o, u, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(n, a, o, u, s, "throw", e);
      }
      u(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var axios = require("axios"),
  JourneyResume = function () {
    return _createClass(function e(t) {
      _classCallCheck(this, e), this.CLIENTID = t, console.log("JourneyResume clientID:", this.CLIENTID);
    }, [{
      key: "getJourneyData",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, axios({
                method: "get",
                url: "https://api2.getmybubble.io/fetch1?data_category=id_mapping&dget3=sprajapati@getmybubble.com"
              });
            case 2:
              return t = (t = e.sent).data.output_data, console.log("masterData", t), r = _toConsumableArray(new Set(t.map(function (e) {
                return e.dput6;
              }))), console.log("uniqueEvents", r), e.abrupt("return", {
                existingPolicies: [{
                  date: "08/09/2021",
                  status: "Policy Generated",
                  policy_number: "BT000012",
                  url: "https://www.stage-www.getmybubble.com"
                }, {
                  date: "08/10/2021",
                  status: "Policy Generated",
                  policy_number: "BT000024",
                  url: "https://www.stage-www.getmybubble.com"
                }],
                trackPolicies: [{
                  date: "08/10/2021",
                  status: "Application Submitted",
                  url: "https://www.stage-www.getmybubble.com/applicationStatus/wewew-2323d-sddsd",
                  card_details: {
                    carrier_logo: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
                    carrier_title: "NEXT Term Life",
                    carrier_sub_title: "Standard Non-Tobacco",
                    quote_amount_value: "$127.12",
                    quote_amount_unit: "mo",
                    policy_number: "BT00073100",
                    insured_details: {
                      insured_name: "Ross Geller",
                      gender: "Female",
                      age: "34 years old",
                      coverage_amount: "$1,100,000"
                    }
                  }
                }, {
                  date: "08/11/2021",
                  status: "Application Submitted",
                  url: "https://www.stage-www.getmybubble.com/applicationStatus/wewew-2323d-sddsd",
                  card_details: {
                    carrier_logo: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
                    carrier_title: "NEXT Term Life",
                    carrier_sub_title: "Standard Non-Tobacco",
                    quote_amount_value: "$127.12",
                    quote_amount_unit: "mo",
                    policy_number: "BT00073100",
                    insured_details: {
                      insured_name: "Ross Geller",
                      gender: "Female",
                      age: "34 years old",
                      coverage_amount: "$1,100,000"
                    }
                  }
                }],
                resumeQuotes: [{
                  date: "08/10/2021",
                  status: "Life Quote",
                  url: "https://www.stage-www.getmybubble.com/selected-quote-url"
                }, {
                  date: "08/11/2021",
                  status: "Home Quote",
                  url: "https://www.stage-www.getmybubble.com/recommeded-quote-url"
                }, {
                  date: "08/11/2021",
                  status: "Home+Life Quote",
                  url: "https://www.stage-www.getmybubble.com/recommeded-quote-url"
                }, {
                  date: "08/04/2021",
                  status: "Home Quote",
                  url: "https://www.stage-www.getmybubble.com/recommeded-quote-url"
                }],
                resumeApplications: [{
                  date: "08/04/2021",
                  status: "Life Application",
                  url: "https://www.stage-www.getmybubble.com/resumeFlow/4er3r"
                }, {
                  date: "08/04/2021",
                  status: "Home Application",
                  url: "https://www.stage-www.getmybubble.com/resumeFlow/5rtrt"
                }, {
                  date: "08/04/2021",
                  status: "Home + Life Application",
                  url: "https://www.stage-www.getmybubble.com/resumeFlow/6jdfjd"
                }],
                personalDetails: {
                  firstname: "Ross",
                  lastname: "Geller",
                  email: "rossgellar@gmail.com",
                  phone: "234-234-1234"
                }
              });
            case 9:
            case "end":
              return e.stop();
          }
        }, e);
      })), function () {
        return e.apply(this, arguments);
      })
    }]);
    var e;
  }();
module.exports = {
  JourneyResume: JourneyResume
};